<template>
  <div>
    <el-table :data="tableData" border style="width: 100%" :style="listHeight">
      <el-table-column prop="INSTANCE" label="任务编号" width="130"></el-table-column>
      <el-table-column prop="TASKNAME" label="任务名称"></el-table-column>
      <el-table-column prop="TASKSTATENAME" label="执行状态" width="100"></el-table-column>
    </el-table>
    <div class="button">
      <el-button
        type="primary"
        size="mini"
        v-if="isShowSubtask"
        @click="showDialog"
        icon="el-icon-circle-plus-outline"
      >添加子任务</el-button>
    </div>
    <side-tags-subtask-sub-dialog ref="SideTagsSubtaskSubDialog"></side-tags-subtask-sub-dialog>
  </div>
</template>

<script>
import selectContactor from "@/components/basicData/selectContactorComponent.vue";
import SideTagsSubtaskSubDialog from "./SideTagsSubtaskSubDialog.vue";
import Editor from "@/components/common/editor";
import { getToken } from "@/util/auth";
import {
  GetTaskTypeList,
  acceptTask,
  GetAllSubTasksByParentTaskId,
  GetAllServerCenterByCustomerId,
  AddAssignTask
} from "@/api/modules/basicData/task";
import $http from "@/api/index";
export default {
  components: {
    selectContactor,
    SideTagsSubtaskSubDialog,
    Editor
  },
  data() {
    return {
      dialogFormVisible: false,
      Reception: "",
      ReceptionList: [],
      timetype: "1",
      num6: "1",
      user: {},
      isShowSubtask: false, //是否显示子任务按钮
      taskLevel: [
        {
          value: "0",
          label: "重要且紧急"
        },
        {
          value: "1",
          label: "重要不紧急"
        },
        {
          value: "2",
          label: "紧急不重要"
        },
        {
          value: "3",
          label: "不重要不紧急"
        }
      ],
      eventInfo: {
        CONTENT: "",
        SERVERCENTERNAME: "",
        SERVERCENTERID: "",
        EVENTNAME: "",
        EVENTTYPENAME: "",
        EVENTTYPEID: "",
        TASKDEGREE: "",
        ADDRESSSEL: ""
      },
      TaskType: "",
      TaskTypeList: "",
      form: {
        TaskTitle: "",
        Executor: "",
        TaskLevelSel: "",
        EstimatedTime: [],
        PLANWORKLOAD: 1,
        PLANWORKLOADUNIT: "0",
        Content: ""
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      formLabelWidth: "120px",
      tableData: []
    };
  },
  created() {
    let a = $(window).height();
    this.listHeight = "height:" + (a - 160) + "px;";
  },
  methods: {
    initalTask: function() {
      if (!this.task || this.tabIndex !== "3") return;
      this.user = getToken();
      // if ((this.task.STATE === 0 && (user.userId === this.task.EXCUTEUSERID || this.task.EXCUTEUSERID === null)) || (this.task.STATE === 1 && user.userId === this.task.EXCUTEUSERID)) {
      this.isShowSubtask =
        (this.task.STATE == 0 || this.task.STATE == 1) &&
        (!this.task.EXCUTEUSERID
          ? false
          : this.task.EXCUTEUSERID == this.user.userId
          ? true
          : false);
      // }
      GetAllSubTasksByParentTaskId(this.task.ID).then(res => {
        if (!res) this.tableData = [];
        else this.tableData = res;
      });
    },
    showDialog: function() {
      if (this.task.STATE == 0) {
        this.AcceptTask(this.task);
      }
      this.$refs.SideTagsSubtaskSubDialog.dialogFormVisible = true;
      this.$refs.SideTagsSubtaskSubDialog.type = 0;
    },
    AcceptTask(task) {
      //接收任务
      let data = {
        TaskId: task.ID,
        ServerId: task.SERVERCENTERID,
        UserName: this.user.realName,
        UserId: this.user.userId,
        DeptId: this.user.departmentId,
        DeptName: this.user.departmentName,
        Location: ""
      };
      acceptTask(data).then(res => {
        // if (res.ResultCode == 1) {
        //   alert('成功');
        // } else {
        //   alert('失败');
        // }
      });
    }
  },
  computed: {
    task: function() {
      return this.$store.state.task.curTask;
    },
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    Reception: {
      handler(val, oldVal) {
        for (var i = 0; i < this.ReceptionList.length; i++) {
          if (this.ReceptionList[i].NAME == val) {
            this.eventInfo.SERVERCENTERNAME = this.ReceptionList[i].NAME;
            this.eventInfo.SERVERCENTERID = this.ReceptionList[i].ID;
            this.equipmentId = this.ReceptionList[i].ID;
            break;
          }
        }
      }
    },
    TaskType: {
      handler(val, oldVal) {
        for (var i = 0; i < this.TaskTypeList.length; i++) {
          if (this.TaskTypeList[i].ID == val) {
            this.eventInfo.EVENTTYPENAME = this.TaskTypeList[i].NAME;
            this.eventInfo.EVENTTYPEID = this.TaskTypeList[i].ID;
            break;
          }
        }
      }
    }
  }
};
</script>

<style scoped=true>
.el-tabs__content {
  line-height: 20px;
}
.el-table__row {
  line-height: 20px;
}
.has-gutter tr {
  background-color: #f3f3f3;
  height: 38px;
}
.el-table__body-wrapper {
  background-color: white;
}
.el-table .cell {
  line-height: 13px;
}
.el-table__row .el-table_1_column_1,
.el-table__row .el-table_1_column_2 {
  color: #0099ff;
}
.button .el-button {
  background: #ecf5ff;
  color: #0099ff;
}
.button {
  margin: 20px 0 10px 20px;
  float: left;
}
.el-dialog__header {
  text-align: left;
}
.el-dialog__body {
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  text-align: left;
}
</style>
